module.exports = __webpack_public_path__ + "static/media/onder_de_vlinderboom.a78b70fe.jpg";